import './PageNotFoundPage.css'

export default function PageNotFoundPage() {
  return (
    <div className="not-found-page">
      <div className="not-found-page__container">
        <h1>404: Seite nicht gefunden</h1>
      </div>
    </div>
  )
}
